/** Single seam over navigator.onLine so tests can stub connectivity. */
export const isOnline = (): boolean => window.navigator.onLine;
